import React, { useEffect } from "react";
import { Modal, Form, Input, Select, message } from "antd";
import api from "../../services/api";

const { Option } = Select;

const PlayerFormModal = ({
  open,
  onClose,
  onSuccess,
  teamId = null,          // 🔥 ADD THIS
  editingPlayer = null,
}) => {
  const [form] = Form.useForm();

  // ---------------------------
  // Prefill on edit
  // ---------------------------
  useEffect(() => {
    if (editingPlayer) {
      form.setFieldsValue({
        name: editingPlayer.name,
        role: editingPlayer.role,
        country: editingPlayer.country,
      });
    } else {
      form.resetFields();
    }
  }, [editingPlayer, form]);

  // ---------------------------
  // Submit
  // ---------------------------
  const handleSubmit = async (values) => {
    try {
      let playerId;

      // 1️⃣ Create or Update Player
      if (editingPlayer) {
        await api.put(
          `/players/${editingPlayer.player_id}`,
          values
        );
        playerId = editingPlayer.player_id;
      } else {
        const res = await api.post("/players", values);
        playerId = res.data.data.player_id;
      }

      // 2️⃣ Attach player to team (only in match flow)
      if (teamId) {
        await api.post("/team-players", {
          team_id: teamId,
          player_id: playerId,
        });
      }

      message.success("Player saved successfully");
      onSuccess?.();
      onClose();
      form.resetFields();
    } catch (err) {
      console.error(err);
      message.error("Failed to save player");
    }
  };

  return (
    <Modal
      title={editingPlayer ? "Edit Player" : "Add Player"}
      open={open}
      onCancel={onClose}
      okText={editingPlayer ? "Update" : "Add"}
      onOk={() => form.submit()}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{ role: "batsman" }}
      >
        <Form.Item
          label="Player Name"
          name="name"
          rules={[{ required: true, message: "Please enter player name" }]}
        >
          <Input placeholder="Enter player name" />
        </Form.Item>

        <Form.Item
          label="Role"
          name="role"
          rules={[{ required: true, message: "Please select role" }]}
        >
          <Select>
            <Option value="batsman">Batsman</Option>
            <Option value="bowler">Bowler</Option>
            <Option value="allrounder">Allrounder</Option>
            <Option value="wicketkeeper">Wicketkeeper</Option>
          </Select>
        </Form.Item>

        <Form.Item label="Country" name="country">
          <Input placeholder="Enter country name" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PlayerFormModal;
